import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { API_ENDPOINT } from '../../../configurations/global.config';
import CreateEntityDrawer from '../../common/create-entity-drawer/create-entity-drawer';
import CustomersListing from './customers-listing/customers-listing';
import CreateCustomerForm from '../../common/create-customer-form/create-customer-form';
import { DataResources, ResourceActionType, user_has_data_model_access } from '../../../utils/permissions';
import { useContext } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';

function Customers() {
  const {user} = useContext(AuthContext)
  return (
    <div className="content-container">
      <Box>
        <Typography
          variant="h3"
          component="h3"
          sx={{ textAlign: 'center', mt: 3, mb: 3 }}
        >
          Customers
        </Typography>
        <Grid container spacing={2}>
          <Grid xs={4}></Grid>
          <Grid xs={4}></Grid>
          <Grid xs={4} sx={{ textAlign: 'right' }}>
            <CreateEntityDrawer disabled={!user_has_data_model_access(user, DataResources.CUSTOMER, ResourceActionType.CREATE)}>
              <CreateCustomerForm />
            </CreateEntityDrawer>
          </Grid>
          <Grid xs={12}>
            <CustomersListing />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Customers;
